// extracted by mini-css-extract-plugin
export default {"card":"CardButton_card__uCSG9"};